import React, { Component } from "react";
import { Translate } from "react-redux-i18n";

const TIP_KEYS = [
  "transaction_tip_1",
  "transaction_tip_2",
  "transaction_tip_3",
  "transaction_tip_4",
  "transaction_tip_5",
  "transaction_tip_6",
  "transaction_tip_7",
];

class TipsGoodTransaction extends Component {
  render() {
    return (
      <div className="transaction-tips-card">
        <div className="transaction-tips-card__header">
          <h5>
            <Translate value="transaction_tips_title" />
          </h5>
        </div>
        <div className="transaction-tips-card__body">
          <ul className="transaction-tips-card__list">
            {TIP_KEYS.map((key) => (
              <li key={key}>
                <Translate value={key} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default TipsGoodTransaction;
